; (() => {
  const dialog = document.querySelector('dialog');
  const { id } = dialog.dataset;
  const showButtons = document.querySelectorAll(`button[data-open-dialog="${ id }"]`);
  const closeButton = document.querySelector('[data-close-dialog]');

  if (dialog && showButtons.length > 0) {

    showButtons.forEach(showButton => {
      showButton.addEventListener('click', () => {
        dialog.showModal();
        document.body.classList.add('overflow-hidden');
      });

      closeButton?.addEventListener('click', () => {
        dialog.close();
        document.body.classList.remove('overflow-hidden');
      });
    });
  }
})();
